// GENERATED FILE. Do not edit by hand.
// Source: the `i18n/*.json` files beside it. Regenerate with `pnpm run buildI18n` after changing
// a string. See `scripts/build-i18n.mjs` for why the strings ship as TypeScript.

import { ChatbotTranslations } from "./translations";

/** Keyed by language, one entry per `i18n/<language>.json`. */
export const CHATBOT_TRANSLATIONS: Record<string, ChatbotTranslations> = {
    "de": {
        "chatPlaceholder": "Schreibe eine Nachricht...",
        "newChat": "Neuer Chat",
        "firstMessage": "Hallo! Wie kann ich Ihnen heute helfen?",
        "awaitingCredentials": "Verbindung mit Ihrem Konto wird hergestellt...",
        "errorGeneric": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        "chats": "Chats",
        "noConversations": "Noch keine Unterhaltungen.",
        "openSidebar": "Unterhaltungen öffnen",
        "closeSidebar": "Unterhaltungen schließen",
        "conversationActions": "Aktionen für die Unterhaltung",
        "rename": "Umbenennen",
        "delete": "Löschen",
        "cancel": "Abbrechen",
        "testConversation": "Test",
        "deleteConversation": "Unterhaltung löschen",
        "deleteConversationConfirm": "„{{title}}“ löschen? Sie wird aus dem Verlauf entfernt.",
        "changeView": "Ansicht wechseln",
        "switchTo": "Wechseln zu",
        "closeChat": "Schließen",
        "openSettings": "Einstellungen",
        "settings": "Einstellungen",
        "textSize": "Textgröße",
        "brandName": "Ava",
        "switchAgent": "Agent wechseln",
        "switchAgentTitle": "Zu einem anderen Agenten wechseln",
        "searchAgents": "Agenten suchen",
        "noAgentsFound": "Keine Agenten gefunden.",
        "testModeBanner": "Testgespräch mit {{agent}} — kein echter Datenverkehr.",
        "testModeBannerAs": "Testgespräch mit {{agent}}, als {{domain}} — kein echter Datenverkehr.",
        "signIn": {
            "username": "Als {{domain}}-Benutzer anmelden, um diesen Agenten zu testen.\n\nBenutzername",
            "password": "Als {{domain}}-Benutzer anmelden, um diesen Agenten zu testen.\n\nPasswort",
            "field": "Als {{domain}}-Benutzer anmelden, um diesen Agenten zu testen.\n\n{{field}}",
            "failed": "Die Anmeldung als {{domain}} hat nicht funktioniert, daher kann dieser Agent noch nichts beantworten.",
            "changeUser": "{{domain}}-Benutzer wechseln",
            "changeUserHint": "Fragt die Zugangsdaten erneut ab. Bis dahin kann dieser Agent nichts beantworten.",
            "required": "Dieser Agent antwortet {{domain}}-Benutzern und kann daher nur als einer von ihnen getestet werden.",
            "action": "Als {{domain}} anmelden",
            "continueAs": "Als {{domain}}-Besucher fortfahren",
            "newIdentity": "Als neuer {{domain}}-Besucher neu beginnen",
            "newIdentityHint": "Ein bisher unbekannter Besucher, sodass Fragenlimit und Lead-Erfassung bei null beginnen."
        },
        "view": {
            "floating": "Schwebend",
            "sidebar": "Seitenleiste",
            "fullscreen": "Vollbild"
        }
    },
    "en": {
        "chatPlaceholder": "Type a message...",
        "newChat": "New Chat",
        "firstMessage": "Hello! How can I help you today?",
        "awaitingCredentials": "Connecting to your account...",
        "errorGeneric": "Something went wrong. Please try again.",
        "chats": "Chats",
        "noConversations": "No conversations yet.",
        "openSidebar": "Open conversations",
        "closeSidebar": "Close conversations",
        "conversationActions": "Conversation actions",
        "rename": "Rename",
        "delete": "Delete",
        "cancel": "Cancel",
        "testConversation": "Test",
        "deleteConversation": "Delete conversation",
        "deleteConversationConfirm": "Delete “{{title}}”? It will be removed from your history.",
        "changeView": "Switch view",
        "switchTo": "Switch to",
        "closeChat": "Close",
        "openSettings": "Settings",
        "settings": "Settings",
        "textSize": "Text size",
        "brandName": "Ava",
        "switchAgent": "Switch agent",
        "switchAgentTitle": "Switch to another agent",
        "searchAgents": "Search agents",
        "noAgentsFound": "No agents found.",
        "testModeBanner": "Test conversation with {{agent}} — not real traffic.",
        "testModeBannerAs": "Test conversation with {{agent}}, held as {{domain}} — not real traffic.",
        "signIn": {
            "username": "Sign in as a {{domain}} user to try this agent out.\n\nUsername",
            "password": "Sign in as a {{domain}} user to try this agent out.\n\nPassword",
            "field": "Sign in as a {{domain}} user to try this agent out.\n\n{{field}}",
            "failed": "Signing in as {{domain}} did not work, so this agent cannot be asked anything yet.",
            "changeUser": "Change {{domain}} user",
            "changeUserHint": "Asks for the credentials again. Until they are given, this agent cannot be asked anything.",
            "required": "This agent answers {{domain}} users, so it can only be tried out as one of them.",
            "action": "Sign in as {{domain}}",
            "continueAs": "Continue as a {{domain}} visitor",
            "newIdentity": "Start over as a new {{domain}} visitor",
            "newIdentityHint": "A visitor nobody has seen before, so a free question limit and the lead capture start from zero."
        },
        "view": {
            "floating": "Floating",
            "sidebar": "Sidebar",
            "fullscreen": "Full screen"
        }
    },
    "it": {
        "chatPlaceholder": "Scrivi un messaggio...",
        "newChat": "Nuova chat",
        "firstMessage": "Ciao! Come posso aiutarti oggi?",
        "awaitingCredentials": "Connessione al tuo account in corso...",
        "errorGeneric": "Si è verificato un errore. Riprova.",
        "chats": "Chat",
        "noConversations": "Nessuna conversazione.",
        "openSidebar": "Apri le conversazioni",
        "closeSidebar": "Chiudi le conversazioni",
        "conversationActions": "Azioni sulla conversazione",
        "rename": "Rinomina",
        "delete": "Elimina",
        "cancel": "Annulla",
        "testConversation": "Test",
        "deleteConversation": "Elimina conversazione",
        "deleteConversationConfirm": "Eliminare “{{title}}”? Sarà rimossa dalla cronologia.",
        "changeView": "Cambia visualizzazione",
        "switchTo": "Passa a",
        "closeChat": "Chiudi",
        "openSettings": "Impostazioni",
        "settings": "Impostazioni",
        "textSize": "Dimensione testo",
        "brandName": "Ava",
        "switchAgent": "Cambia agente",
        "switchAgentTitle": "Passa a un altro agente",
        "searchAgents": "Cerca agenti",
        "noAgentsFound": "Nessun agente trovato.",
        "testModeBanner": "Conversazione di test con {{agent}} — non è traffico reale.",
        "testModeBannerAs": "Conversazione di test con {{agent}}, come {{domain}} — non è traffico reale.",
        "signIn": {
            "username": "Accedi come utente {{domain}} per provare questo agente.\n\nNome utente",
            "password": "Accedi come utente {{domain}} per provare questo agente.\n\nPassword",
            "field": "Accedi come utente {{domain}} per provare questo agente.\n\n{{field}}",
            "failed": "L'accesso come {{domain}} non è riuscito, quindi a questo agente non si può ancora chiedere nulla.",
            "changeUser": "Cambia utente {{domain}}",
            "changeUserHint": "Richiede di nuovo le credenziali. Finché non vengono date, a questo agente non si può chiedere nulla.",
            "required": "Questo agente risponde agli utenti {{domain}}, quindi si può provare solo come uno di loro.",
            "action": "Accedi come {{domain}}",
            "continueAs": "Continua come visitatore {{domain}}",
            "newIdentity": "Riparti come nuovo visitatore {{domain}}",
            "newIdentityHint": "Un visitatore mai visto prima, così il limite di domande gratuite e la raccolta lead ripartono da zero."
        },
        "view": {
            "floating": "Flottante",
            "sidebar": "Barra laterale",
            "fullscreen": "Schermo intero"
        }
    }
};
